<template>
  <div class="relative min-h-screen">
    <img
      v-if="background"
      src="/img/illustrations/jpg/bg.jpg"
      class="fixed top-0 left-0 object-cover object-center w-full h-full"
      alt="BG"
    >
    <slot />
  </div>
</template>

<script>
export default {
  name: "v-master",
  props: {
    background: {
      default: true,
      type: Boolean,
    }
  }
};
</script>
